import {PRODUCTION} from '../../environments';

export enum Service {
  CUSTOMER_APPLICATION_SERVICE = 'limosa',
  COMPANY_DATA_SERVICE = 'ibis',
  OPEN_BANKING_SERVICE = 'mallard',
  SALESFORCE_CUSTOMER_APPLICATION_SERVICE = 'rook',
  SYSTEM_OF_RECORD_SERVICE = 'system-of-record',
  DOCUMENT_UPLOAD_SERVICE = 'document-service',
}

const getUrl = (service: Service): string => {
  if (process.env.STAGE === 'test') {
    return '';
  }

  let environment = 'dev';

  if (process.env.STAGE === PRODUCTION) {
    environment = 'prod'; // don't use const here, they're unrelated
  }

  return `https://${service}.${environment}.service.fundingoptions.com`;
};

export default getUrl;
